module.exports = __webpack_public_path__ + "static/media/5_Hard_to_ignore.70b2f8be.svg";